import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

import $ from 'jquery'
import PubSub from 'pubsub-js';
import screenfull from 'screenfull';

import './App.css';
import '../services/MyoService'; 
import topics from '../topics';

// ordered page collection to determine swipe direction
const pages = ['splash', 'setup', 'live', 'video' ];

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      swipeAnimation: 'swipeLeft'
    };

    this.initSettings();
  }

  initSettings() {
    let shay = {
      layout: {
        type: 0,
        spaceX: 15,
        spaceY: 15
      },
      pattern: {
        type: 0,
        size: 50,
        border: 1
      },
      contrast: {
        type: 2,
        color1: '#d3c7b1',
        color2: '#ffffff'
      }
    };

    let luca = {
      layout: {
        type: 1,
        spaceX: 15,
        spaceY: 15
      },
      pattern: {
        type: 3,
        size: 50,
        border: 1
      },
      contrast: {
        type: 2,
        color2: '#cdd2d4',
        color1: '#ffffff'
      }
    };

    sessionStorage.setItem('pattern-ee-e8-75-5e-e4-57', JSON.stringify(shay));
    sessionStorage.setItem('pattern-f7-f2-d6-cf-43-29', JSON.stringify(luca));
  }

  componentDidMount() {
    // DOM listeners
    $(document).on('keydown', this._catchKeydown);

    // PubSub listener
    PubSub.subscribe(topics.keyPress, this._handleKeypress);
  }

  componentWillUnmount() {
    $(document).off('keydown', this.catchKeydown);

    PubSub.unsubscribe(topics.keyPress, this.handleKeyPress);
  }

  componentWillReceiveProps(nextProps) {
    let oldIndex = this._getPageIndex();
    let newIndex = this._getPageIndex(nextProps.location.pathname);

    this.setState({
      swipeAnimation : oldIndex < newIndex ? 'swipeLeft' : 'swipeRight'
    });
  }

  render() {
    // define current page path as the key of the transition
    const key = this.props.location.pathname.split('/')[1];
    let { swipeAnimation } = this.state;

    return (
      <div className="app no-select flex-column flex-fill">
        <ReactCSSTransitionGroup
            component="div" className="flex-column flex-fill" transitionName={swipeAnimation}
            transitionEnterTimeout={1000} transitionLeaveTimeout={1000}>
            {React.cloneElement(this.props.children || <div />, { key })}
          </ReactCSSTransitionGroup>
      </div>
    );
  }

  _getPageIndex(pathname) {
    if (!pathname) pathname = this.props.location.pathname;
    let pageName = pathname.split('/')[1];
    return pages.indexOf(pageName);
  }

  _catchKeydown(e) {
    e.preventDefault();
    PubSub.publish(topics.keyPress, e.keyCode);
  }

  _handleKeypress(topic, key) {
    // go fullscreen when Esc key is pressed
    if (key === 27) {
      // emulate a fake click
      $('<div></div>').click(() => {
        if (screenfull.enabled && !screenfull.isFullscreen)
          screenfull.request();
      }).click();
    }
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/containers/App.js
 **/